import { Deserializable } from '../protocols/deserializable';
import { Address } from '../users/dto/address';
import { AccountTypeIdEnum } from '../transactions/enum/account-type-id.enum';
import { TransferInFinancialAdvisorFormGroup } from '../../features/transfer-in-request/form-groups/transfer-in-details-form-group';
import { TransferInReadBack } from '../../features/transfer-in-request/interfaces/transfer-in-read-back';

export class TransferInSubmissionData implements Deserializable, TransferInReadBack {
  public sourceAccountTypeId!: number;
  public accountNumber!: string;
  public institutionName!: string;
  public institutionAddress!: Address | null;
  public financialAdvisor!: ReturnType<TransferInFinancialAdvisorFormGroup['getRawValue']> | null;
  public estimatedAmount!: number;
  public isEntireBalance!: boolean;
  public depositAccountTypeId!: AccountTypeIdEnum;
  public acknowledgedDate!: string | null;

  public onDeserialize(): void {
    const Deserialize = window.injector.Deserialize;
    if (this.institutionAddress) {
      this.institutionAddress = Deserialize.instanceOf(Address, this.institutionAddress);
    }
  }
}
